import React from 'react';
import { Container } from './Loader.styles';

export const Loader = () => <Container>Loading</Container>;
